import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.css']
})
export class NavMenuComponent {
  @Input() userRole: number;


  isExpanded = false;
  constructor(private router: Router) {}

  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }

  myMeetingsReload(event: any) {
    if ( this.router.url === '/meetings') {
        window.location.reload();
    }
  }

  scheduleMeetingReload(event: any) {
    if ( this.router.url === '/main') {
        window.location.reload();
    }
  }
}
